import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
	{
		path: "/clients/",
		exact: true,
		auth: true,
		component: Loadable({
			loader: () => import("./pages/index"),
			loading: LoadingComponent
		})
	}
];



// WEBPACK FOOTER //
// ./src/modules/customer/routes.js